module.exports = __webpack_public_path__ + "static/media/cycling-and-mtb.3a5756a8.jpg";